// extracted by mini-css-extract-plugin
export var header = "header-module--header--Zms1V";
export var headerBg = "header-module--header-bg--RhzSb";
export var Animation = "header-module--Animation--Zx8XY";
export var headerImage = "header-module--header-image--hwhv4";
export var navList = "header-module--nav-list--ChrMS";
export var navItem = "header-module--nav-item--ByuNf";
export var navItemLink = "header-module--nav-item-link--IbAkL";